import { Button } from 'design-system';
import { LayoutDashboard, Pencil } from 'lucide-react';

import {
  DrawerStep,
  useDrawerSteps
} from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { DashboardStep } from '@/features/dashboard/constants/DashboardStep';
import { DASHBOARD_ACTION_BUTTON_WIDTH } from '@/features/dashboard/constants/style';
import { useDashboardEditLockContext } from '@/features/dashboard/state/DashboardEditLockContext';

export const DashboardActionButtons = ({
  setStep,
  hideEditButton = false,
  children
}: {
  setStep: (step: DashboardStep) => void;
  /** Hides the Edit button. Used for the new-dashboard creation flow, where
   * there is nothing yet to edit. */
  hideEditButton?: boolean;
  children?: React.ReactNode;
}) => {
  const { setDrawerStep } = useDrawerSteps();
  const { requestEditLock } = useDashboardEditLockContext();

  const handleAddApp = () => {
    requestEditLock(() => {
      setDrawerStep(DrawerStep.SelectApp);
    });
  };

  return (
    <div className='ml-2 flex gap-2'>
      {children}
      {!hideEditButton && (
        <Button
          size='lg'
          style={{ width: DASHBOARD_ACTION_BUTTON_WIDTH }}
          variant='secondary'
          onClick={() => setStep(DashboardStep.Edit)}
        >
          <Pencil aria-hidden='true' />
          Edit
        </Button>
      )}
      <Button
        size='lg'
        style={{ width: DASHBOARD_ACTION_BUTTON_WIDTH }}
        variant='default'
        onClick={handleAddApp}
      >
        <LayoutDashboard aria-hidden='true' />
        Add app
      </Button>
    </div>
  );
};
